// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"FavoritesContainer_cardWrapper__2G99P","pagination":"FavoritesContainer_pagination__3QmO_"};